import { Outlet, Navigate, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../context/ThemeContext'
import {
  IconLayoutDashboard, IconBuildingSkyscraper, IconUsers,
  IconLogout, IconMoon, IconSun, IconArrowLeft
} from '@tabler/icons-react'

const NAV = [
  { path: '/admin', label: 'Dashboard', icon: IconLayoutDashboard, end: true },
  { path: '/admin/hotels', label: 'Hotels', icon: IconBuildingSkyscraper },
  { path: '/admin/users', label: 'Users', icon: IconUsers },
]

export default function AdminLayout() {
  const { user, loading, logout, isPlatformAdmin } = useAuth()
  const { dark, toggle } = useTheme()
  const navigate = useNavigate()

  if (loading) {
    return (
      <div className="page page-center">
        <div className="container container-tight py-4 text-center">
          <div className="spinner-border text-primary" role="status" />
        </div>
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />
  if (!isPlatformAdmin()) return <Navigate to="/" replace />

  const handleLogout = async () => { await logout(); navigate('/login') }
  const initials = user?.name?.split(' ').map(n => n[0]).join('').toUpperCase() || '?'

  return (
    <div className="page">
      <aside className="navbar navbar-vertical navbar-expand-lg" data-bs-theme="dark" style={{ background: '#1a1a2e' }}>
        <div className="container-fluid">
          <h1 className="navbar-brand navbar-brand-autodark">
            <a href="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
              <span className="d-flex align-items-center gap-2">
                <IconBuildingSkyscraper size={28} />
                <span>
                  <strong>Leadiox</strong>
                  <small className="d-block" style={{ fontSize: '0.65rem', color: '#f59e0b', marginTop: -2, fontWeight: 600, letterSpacing: '0.05em' }}>PLATFORM ADMIN</small>
                </span>
              </span>
            </a>
          </h1>

          <div className="px-3 mb-2">
            <button className="btn w-100 btn-sm d-flex align-items-center gap-2" style={{ background: 'rgba(255,255,255,0.08)', color: '#ccc' }} onClick={toggle}>
              {dark ? <IconSun size={16} /> : <IconMoon size={16} />}
              {dark ? 'Light Mode' : 'Dark Mode'}
            </button>
          </div>

          <div className="collapse navbar-collapse" id="sidebar-menu">
            <ul className="navbar-nav pt-lg-3">
              {NAV.map(item => (
                <li className="nav-item" key={item.path}>
                  <NavLink to={item.path} end={item.end} className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                    <span className="nav-link-icon"><item.icon size={20} /></span>
                    <span className="nav-link-title">{item.label}</span>
                  </NavLink>
                </li>
              ))}

              <li className="nav-item mt-3 pt-3 border-top border-secondary">
                <NavLink to="/" className="nav-link">
                  <span className="nav-link-icon"><IconArrowLeft size={20} /></span>
                  <span className="nav-link-title">Back to CRM</span>
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="mt-auto px-3 py-3 border-top border-secondary">
            <div className="d-flex align-items-center gap-2">
              <span className="avatar avatar-sm rounded-circle" style={{ background: '#f59e0b', color: '#1a1a2e' }}>{initials}</span>
              <div style={{ minWidth: 0, flex: 1 }}>
                <div className="text-white fw-medium" style={{ fontSize: '0.85rem', lineHeight: 1.2 }}>{user?.name}</div>
                <div style={{ fontSize: '0.7rem', color: '#f59e0b' }}>Platform Admin</div>
              </div>
              <button className="btn btn-ghost-secondary btn-sm btn-icon" onClick={handleLogout} title="Sign Out">
                <IconLogout size={18} />
              </button>
            </div>
          </div>
        </div>
      </aside>

      <div className="page-wrapper">
        <div className="page-body">
          <div className="container-xl animate-in">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  )
}
